import React from 'react'
import PropTypes from 'prop-types'

const XMarkIcon = ({ size = '18', color = 'black' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.6054 2.3971L11.5028 9.5L18.5762 16.5737C18.7081 16.6976 18.8137 16.847 18.8865 17.0127C18.9593 17.1785 18.9979 17.3572 19 17.5383C19 17.9259 18.846 18.2976 18.572 18.5717C18.2979 18.8458 17.9262 18.9998 17.5385 18.9998C17.3594 19.0032 17.1814 18.9699 17.0155 18.9021C16.8497 18.8342 16.6994 18.7332 16.574 18.6052L9.50058 11.4584L2.35409 18.6052C2.11844 18.846 1.79934 18.9873 1.4626 18.9998C1.075 18.9998 0.703279 18.8458 0.429202 18.5717C0.155128 18.2976 0.00115507 17.9259 0.00115509 17.5383C-0.00657348 17.352 0.0245144 17.1662 0.0924446 16.9926C0.160375 16.819 0.263662 16.6614 0.395746 16.5298L7.49839 9.5L0.41036 2.41172C0.282816 2.28823 0.18099 2.1407 0.110756 1.97765C0.0405215 1.8146 0.00327294 1.63926 0.00115579 1.46174C0.0011539 1.07412 0.155128 0.702386 0.429203 0.428301C0.703279 0.154216 1.075 0.000237011 1.4626 0.000237028C1.64178 -0.00317045 1.81976 0.0300744 1.98563 0.0979312C2.1515 0.165788 2.30175 0.266825 2.42716 0.394843L9.50058 7.54159L16.6471 0.394843C16.8827 0.153966 17.2018 0.0127184 17.5386 0.000237731C17.9262 0.000237748 18.2979 0.154217 18.572 0.428302C18.846 0.702387 19 1.07413 19 1.46174C18.9956 1.8125 18.8539 2.14865 18.6054 2.3971Z"
        fill={color}
      />
    </svg>
  )
}

XMarkIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
}

export default React.memo(XMarkIcon)
